import { useEffect, useRef, useState } from 'react';

import {
  dropTargetForElements,
  monitorForElements
} from '@atlaskit/pragmatic-drag-and-drop/element/adapter';
import { t } from 'i18next';
import type { ToPlanDropzoneProps } from '../../components/InnerList/ToPlanDropzone.types';
import {
  StyledOverlayBox,
  StyledToPlanContainerBox
} from '../../components/InnerList/ToPlanDropzone.styles';

import CustomScrollContainer from '../../components/CustomScrollContainer/CustomScrollContainer';
import { StyledBoxFlexJustifyCenter } from 'components/shared/Box/Box.styles';

export default function ToPlanDropzonePragmatic({
  children,
  handleDrop
}: ToPlanDropzoneProps) {
  const ref = useRef<HTMLDivElement>(null);
  const [isOver, setIsOver] = useState(false);
  const [isDragging, setIsDragging] = useState(false);

  // Use a ref so that the drop target is registered once and always calls the
  // latest handleDrop without triggering re-registration on every render.
  const handleDropRef = useRef(handleDrop);
  handleDropRef.current = handleDrop;

  useEffect(() => {
    return monitorForElements({
      onDragStart: () => setIsDragging(true),
      onDrop: () => setIsDragging(false)
    });
  }, []);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;

    return dropTargetForElements({
      element: el,
      getData: () => ({
        planningEntityType: '',
        appointmentGroupingEntityId: '',
        planningEntityIdentifier: { entityId: '' },
        scheduleStart: '',
        isToPlan: true
      }),
      onDragEnter: () => {
        setIsOver(true);
        handleDropRef.current?.();
      },
      onDragLeave: () => setIsOver(false),
      onDrop: () => setIsOver(false)
    });
  }, []);

  return (
    <StyledToPlanContainerBox ref={ref} component="div" isOver={isOver}>
      <CustomScrollContainer dragActionActive={isDragging}>
        <StyledBoxFlexJustifyCenter>{children}</StyledBoxFlexJustifyCenter>
        {isOver && (
          <StyledOverlayBox>{t('taskList.dropZone')}</StyledOverlayBox>
        )}
      </CustomScrollContainer>
    </StyledToPlanContainerBox>
  );
}
